import { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
import { BASEAPIURL, showfulldatetime } from '../../../../config';
import { Link } from 'react-router-dom';

function MyInvoices({ forpage }) {
    const [invoiceIni, setInvoiceIni] = useState('INVOICE');
    const [invoices, setInvoices] = useState([]);
    const FetchInvoices = async (objects = {}) => {
        try {
            const res = await fetch(`${BASEAPIURL}/student/getOrderList`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Basic ${localStorage.getItem('loggedToken')}`,
                },
                body: JSON.stringify(objects),
            });
            const resJson = await res.json();
            if (res.status === 200 && resJson && resJson.data && resJson.data.length > 0) {
                setInvoices(resJson.data);
            } else {
                setInvoices([]);
            }
            setInvoiceIni(resJson.invoiceIni);
        } catch (err) {
            console.log(err);
            setInvoices([]);
        }
    };

    useEffect(() => {
        FetchInvoices();
    }, []);
    
    return (
        <>
            <div className="pb-3" forpage={forpage}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="ry_instr_shadow p-3">
                            <h6 className="std_header_on_page">My Invoices</h6>
                            <div style={{ clear: 'both' }}></div>
                            <hr />
                            <table className="mt-2 table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th>Invoice ID</th>
                                        <th>Payment ID</th>
                                        <th>Amount</th>
                                        <th>Date & Time</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {invoices.map((s) => (
                                        <tr>
                                            <td>{invoiceIni}-{s.orderID}</td>
                                            <td>{s.paymentID}</td>
                                            <td>{s.receivedAmount} {s.paymentCurrency}</td>
                                            <td>{showfulldatetime(s.createdAt)}</td>
                                            <td>
                                                <Link
                                                    to={`/invoice/${s._id}`}
                                                    className='btn btn-sm btn-info'
                                                    target="_INVOICE"
                                                >
                                                    View Invoice
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MyInvoices;
